import { render, staticRenderFns } from "./BulkEmailWorkflowQueue.vue?vue&type=template&id=56f7d742&"
import script from "./BulkEmailWorkflowQueue.vue?vue&type=script&lang=ts&"
export * from "./BulkEmailWorkflowQueue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports